import { Navigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '../store/authStore';

// ── Require auth ──────────────────────────────────────────────────────────
export function PrivateRoute({ children }) {
  const { isAuthenticated, role } = useAuthStore();
  const location = useLocation();

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  if (role === 'admin') {
    return <Navigate to="/admin" replace />;
  }
  return children;
}

// ── Require auth + group ──────────────────────────────────────────────────
export function GroupRoute({ children }) {
  const { isAuthenticated, groupId, role } = useAuthStore();
  const location = useLocation();

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  if (role === 'admin') {
    return <Navigate to="/admin" replace />;
  }
  if (!groupId) {
    return <Navigate to="/onboarding" replace />;
  }
  return children;
}

// ── Require specific role ──────────────────────────────────────────────────
export function RoleRoute({ children, requiredRole }) {
  const { isAuthenticated, role, groupId } = useAuthStore();
  const location = useLocation();

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  if (role === 'admin' && requiredRole !== 'admin') {
    return <Navigate to="/admin" replace />;
  }

  const hasRole = (() => {
    if (requiredRole === 'admin') return role === 'admin';
    if (requiredRole === 'leader') return role === 'leader' || role === 'vice-leader';
    return true;
  })();

  if (!hasRole) {
    return (
      <div className="flex items-center justify-center min-h-screen p-8">
        <div className="text-center">
          <div className="text-6xl mb-6">🔒</div>
          <h1 className="heading text-3xl font-bold text-white mb-3">Access Denied</h1>
          <p className="text-white/50 mb-8 max-w-sm mx-auto">
            You don't have permission to access this area. Please contact your group leader.
          </p>
          <a
            href="/dashboard"
            className="btn-primary inline-block"
          >
            Return to Dashboard
          </a>
        </div>
      </div>
    );
  }

  return children;
}
